import { useMutation, useQueryClient } from '@tanstack/react-query';
import GeospatialQueries, { GEOSPATIAL_QUERY_KEYS } from '../query';
import { useGeospatial } from '@stores';

export const useAddressCandidatesMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ address, magicKey }: { address: string; magicKey?: string }) => {
      const results = await GeospatialQueries.findAddressCandidates(address, magicKey);
      return results;
    },
    onSuccess: async (data, variables) => {
      const { setAddressCandidates } = useGeospatial.getState();
      queryClient.setQueryData(
        [GEOSPATIAL_QUERY_KEYS.FIND_ADDRESS_CANDIDATES, variables.address, variables?.magicKey],
        data
      );
      setAddressCandidates(data?.candidates);
    },
    onError: (error, variables) => {
      //@TODO handle error appropriately, e.g., show an error modal or toast
      queryClient.setQueryData(
        [GEOSPATIAL_QUERY_KEYS.FIND_ADDRESS_CANDIDATES, variables.address, variables?.magicKey],
        undefined
      );
      console.error('find address candidates mutation failed:', error);
    },
  });
};
